import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  min-width: 768px;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const TitleBlock = styled.div`
  width: 100%;
  height: 50px;
  padding: 10px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  align-items: center;
`;
export const BodyBlock = styled.div`
  height: calc(100% - 50px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.white};
  box-shadow: 0 3px 6px ${ColorSF2.transparentShadow};
`;
export const InputTitle = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
`;
export const InputBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;
export const InputWrapper = styled.div`
  height: 50px;
  margin: 0 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
export const Input = styled.input`
  width: 330px;
  line-height: 26px;
  font-size: 16px;
  padding: 0 6px;
  margin: 0 4px;
  background-color: ${props =>
    props.error ? ColorSF2.softPink : ColorSF2.whisperGray};
  border: 1px solid ${ColorSF2.mediumGray};
`;
export const Message = styled.div`
  font-size: 14px;
  color: red;
  position: absolute;
  top: 40px;
  left: 4px;
`;
